import { req } from 'react-reqq-lite';
import * as c from './constants';

export const sendCode = (payload, callback = () => {}) => {
  req.post({
    key: c.SEND_CODE,
    url: '/api/forgot_password/send',
    payload,
    onSuccess: () => {
      callback();
    },
  });
};
